// actions/teamActions.js
import {getTeamBySubscriptionId} from '../../user/services/user.services';
import {getAllTeams} from '../../user/services/team.services';


import { getTeamPlayers, deleteTeam as deleteTeamService } from "../../services/team.services"; 
import { getUserSubscriptionDetails } from "../../services/user.services"; 
import { GET_TEAM_DETAILS_SUCCESS, DELETE_TEAM_SUCCESS } from "./types";
export const SELECTED_TEAM = 'SELECTED_TEAM';
export const SELECTED_CLOCK = 'SELECTED_CLOCK';
export const IS_SHARED_ACCOUNT_SELECTED = 'IS_SHARED_ACCOUNT_SELECTED';
export const ALL_TEAMS = 'ALL_TEAMS';
export const LOGOUT = 'LOGOUT';

// Action Creators
export const getTeamDetails = (subscriptionId) => async (dispatch, getState) => {
  try {
    const response = await getUserSubscriptionDetails(subscriptionId, JSON.parse(sessionStorage.getItem("myData")));
    dispatch({
      type: GET_TEAM_DETAILS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.log("Error fetching team details:", error);
    // Handle error state if needed
  }
};

export const deleteTeam = (teamId) => async (dispatch, getState) => {
  try {
    const response = await deleteTeamService(teamId, JSON.parse(sessionStorage.getItem("myData")));
    dispatch({
      type: DELETE_TEAM_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.log("Error deleting team:", error);
    // Handle error state if needed
  }
};

export const GetAllTeamsAction = () => {
  return async (dispatch, getState) => {
    const {
      auth: {user},
    } = await getState();
    try {
      let result = await getAllTeams(user?.token);
      dispatch({
        type: ALL_TEAMS,
        payload: result.data,
      });
    } catch (e) {
      console.log(
        'error in  GetAllTeamsAction =====>>!!',
        e?.response?.data?.responseMessage,
      );
    }
  };
};

export const UpdateSelectedTeam = (selectedteamSubscriptionId = null) => {
  return async (dispatch, getState) => {
    const {
      auth: {user},
    } = await getState();
    try {
      console.log('Dispatching UpdateSelectedTeam for subscription ID:', selectedteamSubscriptionId); // Debugging
      let result = await getTeamBySubscriptionId(
        user?.token,
        selectedteamSubscriptionId,
      );
      dispatch({
        type: SELECTED_TEAM,
        payload: result.data,
      });
      console.log('Selected team updated in store:', result.data); // Debugging
    } catch (e) {
      console.log('error in UpdateSelectedTeam =====>>!!', e?.response?.data);
    }
  };
};
